import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';

import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProformaTemplateExpenseService {

	expenseFreqs: any = [
		{ value: 1, name: 'Per Reservation' },
		{ value: 2, name: 'Per Month' },
		{ value: 3, name: 'Per Year' },
		{ value: 4, name: 'One Time' },
	];

	feeTypes: any = [
		{ value: 'MANAGEMENT_FEE', name: 'Management Fee' },
		{ value: 'MAINTENANCE_FEE', name: 'Maintenance Fee' },
		{ value: 'HOA_FEE', name: 'HOA Fee' },
		{ value: 'OTHER_FEE', name: 'Other Fee' },
		{ value: 'FREE_MANAGEMENT_CREDIT', name: 'Free Management Credit' },
		{ value: 'SIGNON_CREDIT', name: 'Signup Credit' },
		{ value: 'REMODEL_CREDIT', name: 'Remodel Credit' },
		{ value: 'OTHER_CREDIT', name: 'Other Credit' },
		{ value: 'STATE_TAX', name: 'State Tax' },
		{ value: 'LOCAL_TAX', name: 'Local Tax' },
		{ value: 'TRANSIENT_TAX', name: 'Transient Tax' },
	];

	constructor(private http: HttpClient) { }

	urlEndpoint = 'proforma-template-expenses';

	add(expense: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, expense);
	}

	update(expense: any): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, expense);
	}

	delete(id: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`);
	}
}
